import { useRef, useState } from 'react';

import { AgGridReact } from 'ag-grid-react';

import { SimulationSummary } from '@octopus/termination-api';

import { ContractSummaryWithFgtsBalance } from '../types';

export const useTerminationSimulationActions = () => {
  const [formOpen, setFormOpen] = useState(false);
  const [selectedContracts, setSelectedContracts] = useState<
    (ContractSummaryWithFgtsBalance | SimulationSummary)[]
  >([]);
  const tableRef = useRef<AgGridReact<
    ContractSummaryWithFgtsBalance | SimulationSummary
  > | null>(null);

  const handleOpenForm = () => {
    setFormOpen(true);
  };

  const handleCloseForm = () => {
    setFormOpen(false);
  };

  const handleUnselectAll = () => {
    tableRef.current?.api.deselectAll();
  };

  const handleSelectionChanged = () => {
    setSelectedContracts(tableRef.current?.api.getSelectedRows());
  };

  return {
    tableRef,
    handleOpenForm,
    handleCloseForm,
    formOpen,
    handleSelectionChanged,
    selectedContractsCount: selectedContracts.length,
    selectedContracts,
    setSelectedContracts,
    handleUnselectAll,
  };
};
